import { BaseIcon, type BaseIconProps } from '@fountain/ripple/icon';
import React, { forwardRef, useId } from 'react';

import theme from 'theme';

// Source: images/duplicate-applicant-icon.svg. White separators reveal the background.
export const DuplicateApplicantStateIcon = forwardRef<
  SVGSVGElement,
  BaseIconProps
>(function DuplicateApplicantStateIcon(props, ref) {
  const clipId = useId();
  return (
    <BaseIcon
      ref={ref}
      viewBox="0 0 16 16"
      width={16}
      height={16}
      fill={theme.palette.secondary.main}
      stroke="none"
      {...props}
    >
      <defs>
        <clipPath id={clipId}>
          <path
            clipRule="evenodd"
            d="M0 0H16V16H0Z M6 11.5a5.5 5.5 0 1 0 11 0a5.5 5.5 0 1 0-11 0Z"
          />
        </clipPath>
      </defs>
      <g clipPath={`url(#${clipId})`}>
        <path d="M6 6C7.65685 6 9 4.65685 9 3C9 1.34315 7.65685 0 6 0C4.34315 0 3 1.34315 3 3C3 4.65685 4.34315 6 6 6Z" />
        <path d="M12 11.254C12 10.348 11.6467 9.4855 11.016 8.923C10.052 8.062 8.38 7 6 7C3.62 7 1.948 8.062 0.984 8.923C0.353333 9.4855 0 10.348 0 11.254V13H12V11.254Z" />
      </g>
      <path
        fill={theme.palette.error.main}
        fillRule="evenodd"
        d="M7 11.5a4.5 4.5 0 1 0 9 0a4.5 4.5 0 1 0-9 0Z M11 9h1v3h-1Z M11 13h1v1h-1Z"
      />
    </BaseIcon>
  );
});
